import { z } from 'zod';

export type LegalEntity = {
    id: number,
    name: string,
    address: string,
    inn: string,
    kpp: string,
    ogrn: string,
    bank_account: string,
    bank_name: string,
    correspondent_account: string,
    bank_identification_code: string,
    signer_fio: string,
    signer_position: string,
    signer_basis: string,
    signatory_position_and_name: string,
    contract_number: string,
    contract_date: string,
};

export const LegalEntitySchema = z.object({
    id: z.number().nullable(),
    name: z.string().nullable(),
    address: z.string().nullable(),
    inn: z.string().nullable(),
    kpp: z.string().nullable(),
    ogrn: z.string().nullable(),
    bank_account: z.string().nullable(),
    bank_name: z.string().nullable(),
    correspondent_account: z.string().nullable(),
    bank_identification_code: z.string().nullable(),
    signer_fio: z.string().nullable(),
    signer_position: z.string().nullable(),
    signer_basis: z.string().nullable(),
    signatory_position_and_name: z.string().nullable(),
    contract_number: z.string().nullable(),
    contract_date: z.string().nullable(),
});
